import { useEffect, useRef } from 'react';
import create from 'zustand';

export const useScrollState = create<{ isScrolling: boolean }>(() => ({
   isScrolling: false,
}));

export const useHoverState = create<{ hoverIndex: number }>(() => ({
   hoverIndex: -1,
}));

type Timer = ReturnType<typeof setTimeout>;

export const useScrollMonitoring = () => {
   let timer = useRef<Timer>();

   useEffect(() => {
      document.addEventListener(
         'scroll',
         () => {
            clearTimeout(timer.current);
            useScrollState.setState({ isScrolling: true });
            timer.current = setTimeout(() => {
               useScrollState.setState({ isScrolling: false });
            }, 100);
         },
         true
      );
   }, []);
};
